import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { LeadSection } from '../components/LeadSection';
import { ProblemSection } from '../components/ProblemSection';
import { ProductReveal } from '../components/ProductReveal';
import { MechanismSection } from '../components/MechanismSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { CTASection } from '../components/CTASection';
import { SalesFooter } from '../components/SalesFooter';
export function SalesPage() {
  return <main className="min-h-screen bg-slate-900 text-slate-100 font-sans selection:bg-amber-500/30" data-id="element-117">
      <HeroSection data-id="element-118" />
      <LeadSection data-id="element-119" />
      <ProblemSection data-id="element-120" />
      <ProductReveal data-id="element-121" />
      <MechanismSection data-id="element-122" />
      <BenefitsSection data-id="element-123" />
      <CTASection data-id="element-124" />
      <SalesFooter data-id="element-125" />
    </main>;
}